module.exports = __webpack_public_path__ + "static/media/10.f4ec8c7c.jpg";